<template>
  <div class="agent-action-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="700px" class="el-dialogs">
      <p v-for="(item, i) in data" :key="i" class="link">{{'推广链接' + (i+1) + ': ' + item.inviteLink}} <span style="margin-left: 15px;" v-if="item.linkRemark">备注：{{item.linkRemark}}</span> </p>
      <div v-if="data.length === 0">暂无数据</div>
    </el-dialog>
  </div>
</template>
<script>
// import { validatorHanzi } from '@/utils/validator';
export default {
  data() {
    return {
      // 外层弹出框
      dialogVisible: false,
      // 弹窗标题
      title: '推广链接查看',
      data: [],
    };
  },

  methods: {
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true;
      this.data = data.inviteLink.length > 0 ? data.inviteLink : [];
    }
  }
};
</script>

<style lang="scss">
.agent-action-box {
  .el-input {
    width: 220px;
  }
  .checked {
    margin-left: 10px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .page-box {
    margin-top: 35px;
    position: relative;
    height: 40px;
  }
  .el-pagination {
    margin-top: 0 !important;
  }
}
</style>
